document.addEventListener("turbo:load", () => {
  const sortableEl = document.querySelector(".connectedSortable");
  if (sortableEl && window.Sortable) {
    new Sortable(sortableEl, {
      group: "shared",
      handle: ".card-header",
    });

    sortableEl.querySelectorAll(".card-header").forEach((header) => {
      header.style.cursor = "move";
    });
  }
});
